import {
  uaGlobalReleaseConstants,
  addUAGlobalReleaseConstants,
  editUAGlobalReleaseConstants,
} from "../_redux-constants";
import { uaGlobalReleaseService } from "../../_services";

function getUAGlobalRelease() {
  function getUAGlobalReleaseLoad() {
    return { type: uaGlobalReleaseConstants.UA_GLOBAL_RELEASE_LOADING };
  }
  function getUAGlobalReleaseSuccess(data) {
    return {
      type: uaGlobalReleaseConstants.UA_GLOBAL_RELEASE_SUCCESS,
      data,
    };
  }
  function getUAGlobalReleaseFailure(error) {
    return {
      type: uaGlobalReleaseConstants.UA_GLOBAL_RELEASE_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(getUAGlobalReleaseLoad());
    return uaGlobalReleaseService.getUAGlobalRelease().then(
      (data) => {
        dispatch(getUAGlobalReleaseSuccess(data));
      },
      (error) => {
        dispatch(getUAGlobalReleaseFailure(error?.toString()));
      }
    );
  };
}

function addUAGlobalRelease(formData) {
  function addUAGlobalReleaseLoad() {
    return {
      type: addUAGlobalReleaseConstants.ADD_UA_GLOBAL_RELEASE_LOADING,
    };
  }
  function addUAGlobalReleaseSuccess(data) {
    return {
      type: addUAGlobalReleaseConstants.ADD_UA_GLOBAL_RELEASE_SUCCESS,
      data,
    };
  }
  function addUAGlobalReleaseFailure(error) {
    return {
      type: addUAGlobalReleaseConstants.ADD_UA_GLOBAL_RELEASE_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(addUAGlobalReleaseLoad());
    return uaGlobalReleaseService.addUAGlobalRelease(formData).then(
      (data) => {
        dispatch(addUAGlobalReleaseSuccess(data));
      },
      (error) => {
        dispatch(addUAGlobalReleaseFailure(error?.toString()));
      }
    );
  };
}

function editUAGlobalRelease(formData) {
  function editUAGlobalReleaseLoad() {
    return {
      type: editUAGlobalReleaseConstants.EDIT_UA_GLOBAL_RELEASE_LOADING,
    };
  }
  function editUAGlobalReleaseSuccess(data) {
    return {
      type: editUAGlobalReleaseConstants.EDIT_UA_GLOBAL_RELEASE_SUCCESS,
      data,
    };
  }
  function editUAGlobalReleaseFailure(error) {
    return {
      type: editUAGlobalReleaseConstants.EDIT_UA_GLOBAL_RELEASE_FAILURE,
      error,
    };
  }
  return (dispatch) => {
    dispatch(editUAGlobalReleaseLoad());
    return uaGlobalReleaseService.editUAGlobalRelease(formData).then(
      (data) => {
        dispatch(editUAGlobalReleaseSuccess(data));
      },
      (error) => {
        dispatch(editUAGlobalReleaseFailure(error?.toString()));
      }
    );
  };
}

export const uaGlobalReleaseActions = {
  getUAGlobalRelease,
  addUAGlobalRelease,
  editUAGlobalRelease,
};
